export const CARD_UI = "CARD_UI";
export const LIST_UI = "LIST_UI";
export const CARD_UI_RIGHT = "CARD_UI_RIGHT";
export const ALL_HIT_UI_MODES = [LIST_UI, CARD_UI, CARD_UI_RIGHT];

export default ALL_HIT_UI_MODES;
